import { CleaningScopeEnum } from 'app/cross-cutting-concerns/communication/interfaces/pra-api-graphql';
import type { RobotCleaningControlService } from 'app/modules/machine-inventory/RobotCleaningControlService';

export interface ActiveCleaningZones {
  mapId: string | null;
  zoneIds: string[];
}

/**
 * The zones the running CV50 task covers, or null when it isn't an AREA cleaning (whole map, spot,
 * or no report). The map still renders without them, so a failed lookup is not fatal.
 */
export const getActiveCleaningZoneIds = async (
  robotCleaningControlService: RobotCleaningControlService,
  materialNumber: string,
  serialNumber: string
): Promise<ActiveCleaningZones | null> => {
  try {
    const data = await robotCleaningControlService.getCurrentCleaningReport({ materialNumber, serialNumber });
    const report = data?.device?.currentCleaningReport;

    if (report?.scope !== CleaningScopeEnum.Area) {
      return null;
    }

    const zoneIds = [
      ...(report.doneCleaningZones ?? []),
      report.currentCleaningZone,
      ...(report.remainingCleaningZones ?? []),
    ].filter((zoneId): zoneId is string => !!zoneId);

    return { mapId: report.mapId ?? null, zoneIds: Array.from(new Set(zoneIds)) };
  } catch (error) {
    console.error(error);

    return null;
  }
};
